export const credentialFormInitialValues = {
  name: "",
  applicationType: ""
};
